var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgSmallStars(props) {
  const _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: `url(#${_id})`,
    stroke: "#1B5AF6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.324 10.239c-3.584 1.208-4.766 2.553-5.64 5.903-.874-3.35-2.055-4.695-5.64-5.903C4.629 9.03 5.81 7.686 6.684 4.336c.874 3.35 2.056 4.695 5.64 5.903zM16.771 4.65c-2.022.68-2.688 1.435-3.181 3.317-.493-1.882-1.16-2.638-3.182-3.317 2.022-.678 2.689-1.434 3.182-3.316.493 1.882 1.16 2.638 3.181 3.316zM17.034 14.434c-1.497.492-1.99 1.04-2.355 2.404-.365-1.364-.858-1.912-2.355-2.404 1.497-.491 1.99-1.039 2.355-2.403.365 1.364.858 1.912 2.355 2.403z"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })))));
}
export default SvgSmallStars;